"use client";

import { BlurFade } from "@/components/ui/blur-fade";
import { BadgeDollarSign } from "lucide-react";

interface PricingHeroProps {
  title: string;
}

const PricingHero = ({ title }: PricingHeroProps) => {
  return (
    <section className="relative pt-28 md:pt-28 pb-4 md:pb-8 bg-white">
      <div className="container max-w-4xl mx-auto px-4 lg:px-6 text-center">
        <BlurFade delay={0.1}>
          <h1 className="text-2xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-tight text-foreground">
            {title}
          </h1>
        </BlurFade>
        {/* Mobile only - 30-day guarantee */}
        <BlurFade delay={0.2}>
          <div className="flex md:hidden items-center justify-center gap-2 mt-4">
            <BadgeDollarSign className="w-5 h-5 text-foreground flex-shrink-0" />
            <span className="text-xs font-bold text-foreground">
              30-day money-back guarantee
            </span>
          </div>
        </BlurFade>
      </div>
    </section>
  );
};

export default PricingHero;
